import { render, staticRenderFns } from "../routeBoard/routeBoard.html?vue&type=template&id=d8c1eaa4&scoped=true&external"
import script from "../routeBoard/routeBoard.js?vue&type=script&lang=js&external"
export * from "../routeBoard/routeBoard.js?vue&type=script&lang=js&external"
import style0 from "../routeBoard/routeBoard.css?vue&type=style&index=0&id=d8c1eaa4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c1eaa4",
  null
  
)

export default component.exports